
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 20A8 8 0 108 4a8 8 0 000 16zM6.707 9.293a1 1 0 00-1.414 1.414L6.586 12l-1.293 1.293a1 1 0 001.414 1.414L8 13.414l1.293 1.293a1 1 0 001.414-1.414L9.414 12l1.293-1.293a1 1 0 00-1.414-1.414L8 10.586 6.707 9.293z","fill":"#DE6B4F"}})])
          )
        }
      }
    